import { Logout } from "@mui/icons-material";
import { Tabs } from "antd";
import { logOut, selectCurrentUser } from "features/auth/authSlice";

import { useGetDashboardProfileQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";

import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const HclDashNav = () => {
  const currentUser = useSelector(selectCurrentUser);

  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [apiData, setApiData] = useState([]);
  const navigate = useNavigate();

  const { data: userProfile } = useGetDashboardProfileQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

 

  useEffect(() => {
    if (userProfile) {
      setApiData(userProfile?.data);
    }
  }, [userProfile]);
  //  console.log(FarmersData , " FarmersData")

 

  const auth = useAuth();
  const dispatch = useDispatch();

  const handlelogOut = (e) => {
    e.preventDefault();

    localStorage.removeItem("authState");

    localStorage.removeItem("locationStore");
    localStorage.removeItem("districtName");
    localStorage.removeItem("locationList");
    localStorage.removeItem("locationDropdown");
    localStorage.removeItem("reduxState");

    
    dispatch(logOut());
       auth.removeUser();
       auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };

  return (
    <div className="" style={{ background: "#fbfbfb" }}>
      <nav className="d-flex justify-content-between py-2 px-4  border-bottom  align-items-center">
      <img 
  src="/assets/img/LC-logo.png" 
  style={{ height: "40px", cursor: "pointer" }} 
  onClick={() => navigate("/hcl-dashboard")} 
/>
        <h3 style={{ fontWeight: "800" }}>Project MAATI</h3>
        <div>
          <img src="/assets/img/hcl_logo.svg" style={{ height: "16px" }} />
          <button
            onClick={handlelogOut}
            className="mt-1 px-2 mx-2 rounded-1 btn bg-primary p-2 text-white"
          >
            {/* Sign Out{" "} */}
            <Logout
              className=""
              style={{ fontSize: "13px", marginBottom: "2px" }}
            />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default HclDashNav;
